import React from "react";
import { Box } from "@chakra-ui/react";
import { Footer } from "@lubbezposrednio-frontend/commons";
import { isLoggedIn } from "@lubbezposrednio-frontend/core";
import { OrganizerShell } from "./OrganizerShell";
import { LandingHeader } from "../../HomeView/components/LandingHeader/LandingHeader";

/** Publiczny shell — ten sam główny header (LandingHeader) co strona główna + stopka. */
const PublicShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box w="100%" minH="100vh" bg="background" display="flex" flexDirection="column">
    <LandingHeader />
    <Box as="main" flex="1" w="100%">
      {children}
    </Box>
    <Footer />
  </Box>
);

/**
 * Współdzielone publiczne ekrany (głosowanie, zapisy, wyniki) ubrane w odpowiedni chrome:
 * zalogowany organizator widzi panel z sidebarem, niezalogowany — publiczny layout z głównym headerem.
 */
export const AdaptiveShell: React.FC<{ children: React.ReactNode }> = ({ children }) =>
  isLoggedIn() ? <OrganizerShell>{children}</OrganizerShell> : <PublicShell>{children}</PublicShell>;
